/* =============================================================================
   T3BLOGG_OS — assets/syslog.js
   Bottom log strip ticker. Listens to `syslog` CustomEvents from other modules.
   ============================================================================= */

(function () {
  'use strict';
  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);

  function ts() { return new Date().toTimeString().slice(0, 8); }

  function push(text, level = 'ok') {
    const stream = $('#syslog-stream');
    if (!stream) return;
    const max = parseInt(stream.dataset.max || '6', 10);
    const prefix = level === 'err' ? '! ' : '> ';
    const line = document.createElement('span');
    line.className = 'line' + (level === 'err' ? ' err' : level === 'warn' ? ' warn' : '');
    // Build with DOM nodes (not innerHTML) so dynamic text — which can include
    // merchant-set product titles — can never inject markup.
    const t = document.createElement('span');
    t.className = 't';
    t.textContent = ts();
    line.appendChild(t);
    line.appendChild(document.createTextNode(prefix + String(text == null ? '' : text)));
    stream.appendChild(line);
    while (stream.children.length > max) stream.removeChild(stream.firstChild);
  }

  document.addEventListener('syslog', e => {
    const { text, level } = e.detail || {};
    if (text) push(text, level);
  });

  function start() {
    const stream = $('#syslog-stream');
    if (!stream) return;
    const ambient = (stream.dataset.ambient || '').split('\n').map(s => s.trim()).filter(Boolean);
    const interval = parseInt(stream.dataset.interval || '18000', 10);
    const boot = (stream.dataset.boot || '').split('\n').map(s => s.trim()).filter(Boolean);
    boot.forEach(b => push(b));
    if (ambient.length && !REDUCED) {
      let i = 0;
      setInterval(() => push(ambient[i++ % ambient.length]), Math.max(4000, interval));
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Clock in the top bar
  function tickClock() {
    const c = $('#clock');
    if (c) c.textContent = new Date().toTimeString().slice(0, 8);
  }
  tickClock();
  setInterval(tickClock, 1000);
})();
